import { Box } from '@mui/material';

import PremiumFeatureMessage from '@/components/UpgradeToPremium/PremiumFeatureMessage';
import UpgradeToPremiumButton from '@/components/UpgradeToPremium/UpgradeToPremiumButton';
import { Z_INDEX } from '@/constants/z-index';

const PremiumWidgetDenied = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        '&:before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundImage: "url('/img/preview/history-chart.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(5px)',
          transform: 'scale(1.05)',
          zIndex: Z_INDEX.base
        }
      }}
    >
      <Box
        sx={{
          position: 'relative',
          zIndex: Z_INDEX.raised,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
          alignItems: 'center',
          gap: '8px',
          height: '542px'
        }}
      >
        <PremiumFeatureMessage />
        <UpgradeToPremiumButton
          sx={{
            mt: '8px'
          }}
          type='upgrade'
        />
      </Box>
    </Box>
  );
};

export default PremiumWidgetDenied;
